import { FocusableOption } from '@angular/cdk/a11y';
import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[phxOmnifilterFocusableDirective]',
  exportAs: 'phxElement',
  host: {
    focus: 'focus()',
  },
})
export class PhxOmnifilterFocusableDirective implements FocusableOption {
  constructor(public elementRef: ElementRef<HTMLElement>) {}

  @Input() public phxOmnifilterFocusableDirective: string = '';
  @Input() skip?: boolean;

  public focus(): void {
    if (this.skip) {
      return;
    }
    this.elementRef.nativeElement.focus();
  }
}
